export default __webpack_public_path__ + "static/media/wounds-icon.a982903f.svg";